import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import React from "react";

interface QRCodeGeneratorProps {
  url: string;
}

const QRCodeGenerator: React.FC<QRCodeGeneratorProps> = ({ url }) => {
  return (
    <div className="">
      {url && (
        <QRCodeCanvas
          value={url}
          size={150}
          bgColor="#ffffff"
          fgColor="#000000"
          className="p-2 border"
        />
      )}
    </div>
  );
};

export default QRCodeGenerator;
